import { Render } from "../render/Render";
import { useSession } from "../lib/session";
import { apiLogout } from "../lib/api";

export function Settings() {
  const { session } = useSession();
  type Elem = { type: string; props: Record<string, unknown>; children: string[] };
  const elements: Record<string, Elem> = {
    root: {
      type: "Page",
      props: {
        title: "Settings",
        subtitle: session.user?.firstName
          ? `Signed in as ${session.user.firstName} ${session.user.lastName ?? ""}`
          : null,
      },
      children: ["who", "outlets-section"],
    },
    who: {
      type: "Card",
      props: { title: "Your account", eyebrow: null, tone: "plain" },
      children: ["who-body"],
    },
    "who-body": {
      type: "Markdown",
      props: {
        body: [
          `**Name:** ${session.user?.firstName ?? "—"} ${session.user?.lastName ?? ""}`,
          `**Market:** ${session.market ?? "—"}`,
          `**Active outlet:** ${session.activeOutletId ?? "—"}`,
          `**Linked outlets:** ${session.outlets?.length ?? 0}`,
        ].join("\n\n"),
      },
      children: [],
    },
    "outlets-section": {
      type: "Section",
      props: { title: "Linked outlets", density: "regular" },
      children: ["outlets-card"],
    },
    "outlets-card": {
      type: "Card",
      props: { title: null, eyebrow: null, tone: "plain" },
      children: ["outlets-list"],
    },
    "outlets-list": {
      type: "Markdown",
      props: {
        body:
          (session.outlets ?? [])
            .map((o) => `- **${o.outletName ?? o.name ?? "(unnamed)"}** · \`${o.outletId}\`${o.timeZone ? " · " + o.timeZone : ""}`)
            .join("\n") || "_no outlets linked to this account_",
      },
      children: [],
    },
  };
  return (
    <div>
      <Render spec={{ root: "root", elements } as never} />
      <div className="px-8 max-w-6xl mx-auto pb-10">
        <button
          onClick={async () => {
            await apiLogout();
            window.location.href = "/login";
          }}
          className="rounded-full bg-danger text-white px-5 py-2.5 text-sm hover:brightness-105"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
